import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { DropDownsModule, MultiSelectModule } from '@progress/kendo-angular-dropdowns';
import { TableFilterComponent } from './tablefilter.component';
import { FormsModule } from '@angular/forms';
import { DatePickerModule, TimePickerModule, DateInputModule, DateRangeModule } from '@progress/kendo-angular-dateinputs';

@NgModule({
    imports: [
        FlexLayoutModule, CommonModule, FormsModule, 
        DropDownsModule, MultiSelectModule,
        DatePickerModule, TimePickerModule, DateInputModule, DateRangeModule
    ],
    declarations: [TableFilterComponent],
    exports: [TableFilterComponent]
})
export class TableFilterModule { }
